import React from "react";
import { logout, isAuthCancelled } from "../../middleware/api";
import toast from "react-hot-toast";

import "../../styles/logout/logout.scss";

const Logout = () => {
  const onClickLogout = async () => {
    try {
      const result = await logout();
      if (!result.isCurrent()) return;
      toast.success("Successfully logout");
      window.location.href = "/signin";
    } catch (error) {
      if (!isAuthCancelled(error)) toast.error("Logout could not be confirmed. Please try again.");
    }
  };

  return (
    <div>
      <button className="fixed-logout-button " style={{ backgroundColor: "#183E51", color: "white", textAlign: "center" }} onClick={onClickLogout}>
        logout
      </button>
    </div>
  );
};

export default Logout;
